import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-aware class joiner. Later classes win over earlier ones of the same family. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
